import React, { useEffect, useState } from "react";
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import { QrCode, Users, CheckCircle2, Percent, Wifi, Gift, ClipboardList, MousePointerClick } from "lucide-react";
import { api } from "../lib/api";

const CARDS = [
  ["scans", "Сканирований", QrCode],
  ["unique_customers", "Клиентов", Users],
  ["completed", "Завершено", CheckCircle2],
  ["conversion", "Конверсия %", Percent],
  ["wifi_sessions", "Wi-Fi сессий", Wifi],
  ["promo_issued", "Промокодов", Gift],
  ["survey_responses", "Ответов опросов", ClipboardList],
  ["banner_clicks", "Кликов по рекламе", MousePointerClick],
];

export default function Dashboard() {
  const [data, setData] = useState(null);
  const [days, setDays] = useState(30);
  useEffect(() => {
    api.get(`/admin/dashboard?days=${days}`).then((r) => setData(r.data));
  }, [days]);
  if (!data) return <div className="p-10 text-center text-gray-400 font-bold">Загрузка...</div>;
  return (
    <div className="space-y-5" data-testid="admin-dashboard">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <h1 className="font-display font-black text-2xl">Дашборд</h1>
        <div className="flex gap-1.5">
          {[["1", "Сегодня"], ["7", "7 дней"], ["30", "30 дней"], ["90", "90 дней"]].map(([d, l]) => (
            <button key={d} data-testid={`dashboard-filter-${d}`} onClick={() => setDays(+d)}
              className={`px-3 py-1.5 rounded-full text-xs font-bold ${days === +d ? "bg-[#111] text-white" : "bg-white border border-gray-200"}`}>{l}</button>
          ))}
        </div>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        {CARDS.map(([k, label, Icon]) => (
          <div key={k} className="bg-white rounded-2xl p-4 border border-gray-100" data-testid={`stat-${k}`}>
            <div className="flex items-center justify-between"><span className="text-xs font-bold text-gray-400 uppercase">{label}</span><Icon size={16} className="text-[#EFAF04]" /></div>
            <div className="font-display font-black text-2xl mt-1">{data.totals[k]}</div>
          </div>
        ))}
      </div>
      <div className="bg-white rounded-2xl p-4 border border-gray-100">
        <div className="text-sm font-extrabold mb-3">Сканирования / Завершения / Клики</div>
        <div className="h-64">
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={data.series}>
              <defs>
                <linearGradient id="gy" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#FEBC10" stopOpacity={0.5} /><stop offset="100%" stopColor="#FEBC10" stopOpacity={0} /></linearGradient>
                <linearGradient id="gr" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#FF0000" stopOpacity={0.4} /><stop offset="100%" stopColor="#FF0000" stopOpacity={0} /></linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
              <XAxis dataKey="day" tick={{ fontSize: 10 }} />
              <YAxis tick={{ fontSize: 10 }} width={30} />
              <Tooltip />
              <Area type="monotone" dataKey="scan" name="Сканы" stroke="#EFAF04" fill="url(#gy)" strokeWidth={2} />
              <Area type="monotone" dataKey="completed" name="Завершено" stroke="#FF0000" fill="url(#gr)" strokeWidth={2} />
              <Area type="monotone" dataKey="banner_click" name="Клики" stroke="#111" fill="none" strokeWidth={1.5} />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>
      <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden">
        <div className="text-sm font-extrabold p-4 pb-2">Кампании</div>
        <table className="w-full text-sm">
          <thead><tr className="text-left text-xs text-gray-400 uppercase"><th className="px-4 py-2">Название</th><th className="px-2">Тип</th><th className="px-2">Сканы</th><th className="px-2">Завершено</th><th className="px-2">Статус</th></tr></thead>
          <tbody>
            {data.campaigns.map((c) => (
              <tr key={c.id} className="border-t border-gray-50">
                <td className="px-4 py-2.5 font-bold">{c.name?.ru}</td>
                <td className="px-2">{c.type}</td>
                <td className="px-2">{c.scans || 0}</td>
                <td className="px-2">{c.completions || 0}</td>
                <td className="px-2">{c.active ? <span className="text-green-600 font-bold text-xs">Активна</span> : <span className="text-gray-400 text-xs">Выкл</span>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
